import { useId, useState } from 'react';
import { RiArrowDownSLine, RiArrowRightSLine } from 'react-icons/ri';
import { formatDateTime } from 'utils/dates/date.utils';
import { splitByCharacter } from 'utils/strings/string.utils';
import {
  getAlertDescription,
  getAlertEndTime,
  getAlertHeadline,
  getAlertSender,
  getAlertStartTime,
} from '../../utils/alertData.utils';
import { Button } from 'react-bootstrap';

const getDisplayTime = (value) => (value ? formatDateTime(value) : 'Unavailable');

const ForecastAdvisory = ({ alert }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const detailsId = useId();
  const headline = getAlertHeadline(alert);
  const sender = getAlertSender(alert);
  const issuedTime = alert?.issue_time_utc ?? alert?.sentTime;
  const descriptionLines = splitByCharacter(getAlertDescription(alert), '*')
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <article className="m-2 overflow-hidden rounded-2 bg-primary">
      <Button
        aria-controls={detailsId}
        aria-expanded={isExpanded}
        className="d-flex w-100 flex-wrap align-items-start justify-content-between gap-2 border-0 p-3 text-start fw-semibold"
        onClick={() => setIsExpanded((expanded) => !expanded)}
        type="button"
      >
        <span className="min-w-0 text-break">
          {headline} · {sender}
        </span>
        <span className="d-inline-flex flex-shrink-0 align-items-center gap-1 text-nowrap small">
          {getDisplayTime(issuedTime)}
          {isExpanded ? (
            <RiArrowDownSLine aria-hidden="true" size={20} />
          ) : (
            <RiArrowRightSLine aria-hidden="true" size={20} />
          )}
        </span>
      </Button>

      {isExpanded && (
        <div className="border-top border-light-subtle p-3" id={detailsId}>
          <dl className="mb-3 d-flex flex-wrap justify-content-between gap-3 small">
            <div>
              <dt>Valid until</dt>
              <dd className="mb-0">{getDisplayTime(getAlertEndTime(alert))}</dd>
            </div>
            <div>
              <dt>Starts</dt>
              <dd className="mb-0">{getDisplayTime(getAlertStartTime(alert))}</dd>
            </div>
          </dl>

          <ul className="mb-0 ps-4">
            {descriptionLines.map((line, index) => (
              <li className="mb-1" key={`${line}-${index}`}>
                {line}
              </li>
            ))}
          </ul>
        </div>
      )}
    </article>
  );
};

export default ForecastAdvisory;
